/* Auth container and form styles */
.authContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem 1rem;
  background-color: var(--bg-primary, #F7F9FC);
}

.authFormContainer {
  width: 100%;
  max-width: 400px;
  padding: 2rem;
  background-color: var(--bg-secondary, white);
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.authHeader {
  margin-bottom: 2rem;
  text-align: center;
}

.authHeader h2 {
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary, #2D3748);
}

.authHeader p {
  color: var(--text-secondary, #718096);
  font-size: 0.875rem;
}

.authForm {
  width: 100%;
}

.formGroup {
  margin-bottom: 1.5rem;
}

.formGroup label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-primary, #2D3748);
}

.formGroup input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border-color, #E2E8F0);
  border-radius: 0.375rem;
  font-size: 1rem;
}

.authButton {
  display: block;
  width: 100%;
  padding: 0.75rem;
  background-color: var(--primary, #635BFF);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.authButton:hover {
  background-color: var(--primary-dark, #574CE0);
}

.authButton:disabled {
  background-color: var(--gray-400, #CBD5E0);
  cursor: not-allowed;
}

.authError {
  color: var(--danger, #E53E3E);
  background-color: rgba(229, 62, 62, 0.1);
  padding: 0.75rem;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
}

.authSuccess {
  color: var(--success, #38A169);
  background-color: rgba(56, 161, 105, 0.1);
  padding: 0.75rem;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
}

.authLinks {
  margin-top: 1.5rem;
  text-align: center;
  font-size: 0.875rem;
}

.authLinks a {
  color: var(--primary, #635BFF);
  text-decoration: none;
}

.authLinks a:hover {
  text-decoration: underline;
}

.forgotPasswordLink {
  display: block;
  text-align: right;
  margin-bottom: 1rem;
  font-size: 0.875rem;
}

.forgotPasswordLink a {
  color: var(--primary, #635BFF);
  text-decoration: none;
}

.forgotPasswordLink a:hover {
  text-decoration: underline;
}